import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CommentService } from '@service/comments.service';
import { Comment } from '@model/Comment';
import { Message } from '@model/Message';

@Component({
  selector: 'app-modal-comments',
  templateUrl: './modal-comments.component.html',
  styleUrls: ['./modal-comments.component.scss']
})
export class ModalCommentsComponent implements OnInit {

  @Input() private projectId: number;
  @Input() private apiRoute: string;

  commentsForm: FormGroup;
  submitted: boolean = false;
  hideForm: boolean = true;
  hideTable: boolean = false;
  loading: boolean = false;

  private commentId: number = null;

  public comments: Array<Comment> = [];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private toast: ToastrService,
    private commentService: CommentService,
  ) { }

  ngOnInit() {
    this.commentsForm = this.formBuilder.group({
      message: ['', [Validators.required]],
    });

    setTimeout(() => {
      this.loading = true;
      this.commentService.get(this.projectId, this.apiRoute)
      .subscribe((comments: Comment[]) => {
        this.loading = false;
        this.comments = comments;
      });
    }, 0);
  }

  save() {
    this.submitted = true;

    if (this.commentsForm.invalid) {
      return;
    }

    this.submitted = false;

    const formData: any = this.commentsForm.value;

    if (this.commentId) {
      this.commentService.update(this.commentId, {
        ...formData,
        project_id: this.projectId,
        api_route: this.apiRoute
      }).subscribe(() => {
        const index = this.indexComment(this.commentId);
        this.comments[index].message = formData.message;
        this.cancel();
        this.toast.success(Message.SUCCESS);
      });
    } else {
      this.commentService.store({
        ...formData,
        project_id: this.projectId,
        api_route: this.apiRoute
      }).subscribe((comment: Comment) => {
        this.toast.success(Message.SUCCESS);
        this.comments.push(comment);
        this.cancel();
      });
    }
  }

  edit(comment: Comment): void {
    this.showForm();

    const index = this.indexComment(comment.id);

    if (index > -1) {
      this.commentId = comment.id;
      this.commentsForm.patchValue({
        message: comment.message
      });
    }
  }

  solveComment($spinnerCheck: any, $checkIcon: any, comment: Comment) {
    $spinnerCheck.style.display = 'inline-block';
    $checkIcon.style.display = 'none';

    const index = this.indexComment(comment.id);

    if (index > -1) {
      this.commentService.solve(comment.id).subscribe((comment: Comment) => {
        $spinnerCheck.style.display = 'none';
        $checkIcon.style.display = 'inline-block';
        this.comments[index].resolved = comment.resolved;
      });
    }
  }

  delete(comment: Comment): void {
    const index = this.indexComment(comment.id);

    if (index > -1) {
      const confirm = window.confirm(`Deseja realmente excluir a mensagem ${comment.message}?`);
      if (confirm) {
        this.commentService.delete(comment.id).subscribe(() => {
          this.comments.splice(index, 1);
          this.toast.success(Message.SUCCESS);
        });
      }
    }
  }

  private indexComment(id: number): number {
    return this.comments.map(c => c.id).indexOf(id);
  }

  showForm() {
    this.commentId = null;
    this.commentsForm.patchValue({
      message: ''
    });
    this.hideForm = false;
    this.hideTable = true;
  }

  cancel() {
    this.hideForm = true;
    this.hideTable = false;
  }
}
